import script from "./LanguagePicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./LanguagePicker.vue?vue&type=script&setup=true&lang=ts"

import "./LanguagePicker.vue?vue&type=style&index=0&id=474d1e3d&lang=scss"

const __exports__ = script;

export default __exports__